module.exports = __webpack_public_path__ + "media/public/img/skyline-new-logo-96f08eba021a938e387541f51118c232.svg";